import React, { useEffect, useState } from 'react';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { Grid, Paper, Typography } from '@mui/material';
import { XGrid } from 'app/components/Common/XGrid/XGrid';
import { getActivityColumns } from './ReferenceUtils';
import { useTranslation } from 'react-i18next';
import SouthWestOutlinedIcon from '@mui/icons-material/SouthWestOutlined';
import NorthEastOutlinedIcon from '@mui/icons-material/NorthEastOutlined';
import { useAddEditReferenceStyle } from './AddEditReference.style';

const ReferenceActivity = ({ activityHistory, disabled }: { activityHistory: any; disabled: boolean }) => {
  const { t } = useTranslation();
  const { classes } = useAddEditReferenceStyle();
  const apiRef = useGridApiRef();
  const [columns, setColumns] = useState<any>([]);
  useEffect(() => {
    setColumns(getActivityColumns());
  }, []);

  return (
    <Paper variant="outlined" square>
      <Grid container justifyContent={'space-between'} alignItems={'center'} columnSpacing={2} px={2} py={3}>
        <Grid item xs={2}>
          <Typography component={'h4'} className={classes.AdditionalInfoTitle}>
            {t('candidate.workExperience.addEditReference.referenceAdditionalInfo.activity')}
          </Typography>
        </Grid>
        <Grid container xs={9} justifyContent={'space-between'} columnSpacing={1}>
          <Grid item className={disabled ? classes.activityActionDisabled : classes.activityAction}>
            <SouthWestOutlinedIcon sx={{ width: 20, height: 20 }} />
            <Typography component={'span'} variant="body2" pl={1}>
              {t('candidate.workExperience.addEditReference.referenceAdditionalInfo.logInboundActivity')}
            </Typography>
          </Grid>
          <Grid item className={disabled ? classes.activityActionDisabled : classes.activityAction}>
            <NorthEastOutlinedIcon sx={{ width: 20, height: 20 }} />
            <Typography component={'span'} variant="body2" pl={1}>
              {t('candidate.workExperience.addEditReference.referenceAdditionalInfo.logOutboundActivity')}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid xs={12} p={2} pt={0}>
        <XGrid
          apiRef={apiRef}
          columns={columns}
          getRowId={row => row.activityHistoryId}
          rows={activityHistory || []}
          autoHeight={false}
          height={300}
          disablePaggination={true}
          disableSelectionOnClick
          toolbar={false}
          hideFooter={true}
        />
      </Grid>
    </Paper>
  );
};

export default React.memo(ReferenceActivity);
